<div class="topbar hover-top-bar">
  <div class="me-auto">
    <app-menu-top></app-menu-top>
  </div>
  <!-- Right Side -->
  <div>
    <app-copy-url></app-copy-url>
  </div>
  <div>
    <app-weather-status></app-weather-status>
  </div>
  <div>
    <app-plant-name [systemInfo]="systemInfo"></app-plant-name>
  </div>
  <div>
    <app-topbar-user-menu [systemInfo]="systemInfo"></app-topbar-user-menu>
  </div>
</div>
